"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var dealerDetailsStyles = styles_1.makeStyles(function (_a) {
    var _b;
    var breakpoints = _a.breakpoints, palette = _a.palette;
    return ({
        dealerDetailsContainer: {
            display: 'flex',
            width: '100%',
            paddingTop: 12,
            paddingBottom: 27,
            minHeight: 100,
        },
        dealerDetails: (_b = {
                position: 'relative',
                maxWidth: 180
            },
            _b[breakpoints.down('sm')] = {
                maxWidth: '92%',
            },
            _b),
        dealerName: {
            paddingBottom: 10,
            textTransform: 'uppercase',
            color: palette.common.black,
        },
        dealerAddress: {},
        dealerCity: {},
    });
}, { name: 'GqlCheckout_DealerDetails' });
exports.default = dealerDetailsStyles;
